import { Goal, Club, Student, CreateGoalRequest, ClubDate, AggregatedGoalsData } from "@/types";
import { axiosInstance } from "../clients";

async function listMemberGoalsByClub(club_id: Club["id"], student_id: Student["id"]): Promise<{ data: { goals: Goal[] }; meta: { status: 200 } }> {
  return (await axiosInstance.get(`/v1/clubs/${club_id}/students/${student_id}/goals`)).data;
}

async function listAllGoalsInClub(club_id: Club["id"], status: string, category?: string): Promise<{ data: { goals: Goal[], data: Goal[], totalStepsTravelled: number, showNagBanner: boolean }; meta: { status: 200 } }> {
  return (
    await axiosInstance.get(`/v1/clubs/${club_id}/students/goals`, {
      params: {
        status,
        category,
      },
    })
  ).data;
}

async function listMemberArchivedGoalsByClub(club_id: Club["id"], student_id: Student["id"]): Promise<{ data: { goals: Goal[] }; meta: { status: 200 } }> {
  return (await axiosInstance.get(`/v1/clubs/${club_id}/students/${student_id}/goals_archived`)).data;
}

async function createGoal(club_id: Club["id"], student_id: Student["id"], goal: CreateGoalRequest): Promise<{ data: { goal: Goal }; meta: { status: 200 } }> {
  return (await axiosInstance.post(`/v1/clubs/${club_id}/students/${student_id}/goals`, goal)).data;
}

async function updateGoal(club_id: Club["id"], student_id: Student["id"], goal_id: Goal["id"], data: CreateGoalRequest): Promise<{ data: { goal: Goal }; meta: { status: 200 } }> {
  return (await axiosInstance.post(`/v1/clubs/${club_id}/students/${student_id}/goals/${goal_id}`, data)).data;
}

async function generateChildGoalReport(club_id: Club["id"], student_id: Student["id"]): Promise<{ data: { report: string }; meta: { status: 200 } }> {
  return (await axiosInstance.get(`/v1/clubs/${club_id}/students/${student_id}/goals/export/pdf`)).data;
}

async function generateBrickClubReport(club_id: Club["id"]): Promise<{ data: { report: string }; meta: { status: 200 } }> {
  return (await axiosInstance.get(`/v1/clubs/${club_id}/goals/export/pdf`)).data;
}

async function updateGoalProgress(
  club_id: Club["id"],
  student_id: Student["id"],
  goal_id: Goal["id"],
  data: {
    progress: number;
    session_date_id: ClubDate["id"];
    goal_id: Goal["id"];
  }
): Promise<{ data: { goal: Goal }; meta: { status: 200 } }> {
  return (await axiosInstance.post(`/v1/clubs/${club_id}/students/${student_id}/goals/${goal_id}/progress`, data)).data;
}

async function getAggregatedGoalsData(): Promise<{ data: { data: AggregatedGoalsData[] }; meta: { status: 200 } }> {
  return (await axiosInstance.get(`v1/goals/aggregated`)).data.data;
}

export default {
  listMemberGoalsByClub,
  updateGoalProgress,
  listAllGoalsInClub,
  createGoal,
  updateGoal,
  listMemberArchivedGoalsByClub,
  getAggregatedGoalsData,
  generateChildGoalReport,
  generateBrickClubReport,
};
